/* eslint-disable no-underscore-dangle */
const cwaApolloClient = require('client-web-app/apolloClient').default;
const bkApolloClient = require('bk-web-app/graphqlClient').default;
const env = require('bench-environment').default;

class ApolloService {
  constructor($q) {
    this.$q = $q;
    this._client = window.location.href.includes(env.location.cwa)
      ? cwaApolloClient
      : bkApolloClient;
  }

  query(options) {
    return this._wrapper(this._client.query(options));
  }

  mutate(options) {
    return this._wrapper(this._client.mutate(options));
  }

  // Query using bench-backend (v2) endpoint
  queryV2(options) {
    return this._wrapper(
      this._client.query({
        ...options,
        context: { ...options.context, useV2: true },
      }),
    );
  }

  // Mutate using bench-backend (v2) endpoint
  mutateV2(options) {
    return this._wrapper(
      this._client.mutate({
        ...options,
        context: { ...options.context, useV2: true },
      }),
    );
  }

  _wrapper(promise) {
    return this.$q((resolve, reject) => {
      promise.then(resolve).catch(reject);
    });
  }
}

const deps = [];

module.exports = angular
  .module('bench.data.service.apollo', deps)
  .service('apolloService', ApolloService);
